import React, { useEffect, useState } from 'react';
import {
    Grid, Paper
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { json, useParams } from 'react-router-dom';
import { fetchclothstklump } from '../../Store/PHPSlice/clothStock';
import { selectClothstklumplist } from '../Selectors/UploadStock/ReadyMSelector';
import { insertClothIssueLump } from '../../Store/PHPSlice/Cutting/clothIssue';



const ClothIssueLump = () => {

    const { Id, bId } = useParams();
    const [lumpRows, setLumpRows] = useState([]);
    const [newLumprows, setNewLumprows] = useState([]);
    const [lumpTotMtr, setLumpTotMtr] = useState(0);
    const [newTotMtr, setNewTotMtr] = useState(0);
    const dispatch = useDispatch();
    const lumplist = useSelector(selectClothstklumplist);
    const [formData, setFormData] = useState({
        usemtr1: '0',
        balmtr1: '0',
        usemtr2: '0',
        balmtr2: '0'
    });

    const [loading, setLoading] = useState(false);
    const saved = localStorage.getItem("lumpData");
    useEffect(() => {
        dispatch(fetchclothstklump(Id));
    }, [Id]);

    useEffect(() => {
        if (lumplist?.data3?.length > 0) {
            const valdata = JSON.parse(JSON.stringify(lumplist.data3));
            const totmtr = lumplist.data3.reduce((acc, lump) => acc + parseInt(lump.bmtr), 0);
            setLumpTotMtr(totmtr);
            setLumpRows(valdata);

            // const storageData = {
            //     data: valdata,
            //     totmtr: totmtr
            // };
            // localStorage.setItem("lumpData", JSON.stringify(storageData));

            const valdata2 = JSON.parse(JSON.stringify(lumplist.data2));
            const totmtr2 = lumplist.data2.reduce((acc, lump) => acc + parseInt(lump.bmtr), 0);
            setNewTotMtr(totmtr2);
            setNewLumprows(valdata2);

            setFormData(prev => ({
                ...prev,
                usemtr1: totmtr,
                usemtr2: totmtr2
            }));
        }
    }, [lumplist]);
    // console.log(lumplist);


    useEffect(() => {
        if (saved) {
            const parsed = JSON.parse(saved);
            console.log("Lump Records:", parsed.data);
            console.log("Total Mtr:", parsed.totmtr);

            setLumpRows(parsed.data);
            setLumpTotMtr(parsed.totmtr);
        }
    }, [saved]);
    // console.log(newLumprows)

    const handleLumpSelection = (index) => {
        const newRows = [...lumpRows];
        newRows[index].selected = !newRows[index].selected;
        setLumpRows(newRows);
    };

    const handleLumpSelection2 = (index) => {
        const newRows = [...newLumprows];
        newRows[index].selected2 = !newRows[index].selected2;
        setNewLumprows(newRows);
    };

    const handleLumpColor = (index, value) => {
        const updateLumps = [...lumpRows];
        updateLumps[index].color = value;
        setLumpRows(updateLumps);
    };

    const handleLumpMtr = (index, value) => {
        const updateLumps = [...lumpRows];
        updateLumps[index].bmtr2 = value;
        const remtr = parseFloat(updateLumps[index].bmtr) - parseFloat(value);
        if (remtr > 0) {
            updateLumps[index].loose = '1';
        } else {
            updateLumps[index].loose = '0';
        }
        updateLumps[index].balmtr = (remtr).toFixed(2);

        // Calculate the sum of all mtr values in the lumpRows array
        const totalMtr = updateLumps.reduce((sum, lump) => {
            // Ensure that mtr values are numeric and handle potential empty values
            const mtrValue = parseFloat(lump.bmtr2) || 0;
            return sum + mtrValue;
        }, 0);
        const totalbal = updateLumps.reduce((sum, lump) => {
            // Ensure that mtr values are numeric and handle potential empty values
            const mtrValue = parseFloat(lump.balmtr) || 0;
            return sum + mtrValue;
        }, 0);
        // setLumpTotMtr(totalMtr);
        setFormData(prev => ({
            ...prev,
            usemtr1: totalMtr,
            balmtr1: totalbal
        }));
        setLumpRows(updateLumps);
    };

    const handleAddlump = () => {
        let selectedRows = lumpRows.filter(row => row.selected);
        const newTotmtr = selectedRows?.reduce((acc, row) => acc + parseFloat(row.bmtr2), 0);
        const newTotmtr2 = selectedRows?.reduce((acc, row) => acc + parseFloat(row.bmtr), 0);
        selectedRows = selectedRows.map(row => ({
            ...row,
            selected2: false
        }));
        const newbalmtr = selectedRows?.reduce((acc, row) => acc + parseFloat(row.balmtr), 0);
        const newbalmtrprev = newLumprows?.reduce((acc, row) => acc + parseFloat(row.balmtr), 0);
        const finalbalmtr = newbalmtr + newbalmtrprev;
        const newTotmtrprev = newLumprows?.reduce((acc, row) => acc + parseFloat(row.bmtr), 0);
        const newTotmtrprev2 = newLumprows?.reduce((acc, row) => acc + parseFloat(row.bmtr2), 0);
        const finaltotmtr = newTotmtr + newTotmtrprev;
        const finaltotmtr2 = newTotmtr2 + newTotmtrprev2;
        setNewLumprows(prevRows => [...prevRows, ...selectedRows]);
        setNewTotMtr(finaltotmtr2);
        const updatedRows = lumpRows?.filter(row => !row.selected);
        const prevTotmtr = updatedRows?.reduce((acc, row) => acc + parseFloat(row.bmtr), 0);
        const prevbalmtr = updatedRows?.reduce((acc, row) => acc + parseFloat(row.balmtr), 0);
        setLumpTotMtr(prevTotmtr);

        const prevtotmtr2 = updatedRows?.reduce((acc, row) => acc + parseFloat(row.bmtr2), 0);
        setFormData(prev => ({
            ...prev,
            usemtr1: prevtotmtr2,
            usemtr2: finaltotmtr,
            balmtr1: prevbalmtr,
            balmtr2: finalbalmtr
        }));
        setLumpRows(updatedRows);
    };

    const handleRemoveLumps = () => {
        let filteredRows = newLumprows.filter((row) => !row.selected2);
        filteredRows = filteredRows.map(row => ({
            ...row,
            selected: false,
            selected2: false
        }));
        setNewLumprows(filteredRows);
        const totmtr = filteredRows?.reduce((acc, mtr) => acc + parseFloat(mtr.bmtr), 0);
        setNewTotMtr(totmtr);

        let filteredRow2 = newLumprows.filter((row) => row.selected2);
        filteredRow2 = filteredRow2.map(row => ({
            ...row,
            selected: false,
            selected2: false
        }));
        setLumpRows(prevRows => [...prevRows, ...filteredRow2]);
        const prevTotmtr = filteredRow2?.reduce((acc, mtr) => acc + parseFloat(mtr.bmtr), 0);
        const acttotmtr = lumpRows?.reduce((acc, mtr) => acc + parseFloat(mtr.bmtr), 0);
        const finaltotmtr = prevTotmtr + acttotmtr;
        setLumpTotMtr(finaltotmtr);

        const usemtr1 = lumpRows?.reduce((acc, mtr) => acc + parseFloat(mtr.bmtr2), 0);
        const usemtr2 = filteredRow2?.reduce((acc, mtr) => acc + parseFloat(mtr.bmtr2), 0);
        const finalusemtr = usemtr1 + usemtr2;

        const balmtr1 = lumpRows?.reduce((acc, mtr) => acc + parseFloat(mtr.balmtr), 0);
        const balmtr2 = filteredRow2?.reduce((acc, mtr) => acc + parseFloat(mtr.balmtr), 0);
        const finalbalmtr = balmtr1 + balmtr2;

        const newusemtr = filteredRows?.reduce((acc, mtr) => acc + parseFloat(mtr.bmtr2), 0);
        const newbalmtr = filteredRows?.reduce((acc, mtr) => acc + parseFloat(mtr.balmtr), 0);

        setFormData(prev => ({
            ...prev,
            usemtr1: finalusemtr,
            usemtr2: newusemtr,
            balmtr1: finalbalmtr,
            balmtr2: newbalmtr
        }))


    };

    const userId = '1';

    function PostObj(lumpRows, newLumprows, userId, Id, bId) {
        const data = {
            lumpRows: lumpRows,
            newlumpRows: newLumprows,
            usemtr1: formData.usemtr1,
            balmtr1: formData.balmtr1,
            usemtr2: formData.usemtr2,
            balmtr2: formData.balmtr2,
            baleId: Id,
            userId: userId,
            bidx: bId
        };
        return data;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const postData = PostObj(lumpRows, newLumprows, userId, Id, bId);
        console.log(postData);

        const resend = {
            bid: bId,
            baleId: Id,
            totmtr: formData.usemtr2
        };

        if (window.opener && window.opener.handleResendFromChild3) {
            window.opener.handleResendFromChild3(resend);
        }

        dispatch(insertClothIssueLump(postData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Record Added");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    const isAnyRowSelected = lumpRows.some(row => row.selected);
    const isAnyNewRowSelected = newLumprows.some(row => row.selected2);

    return (
        <>
            <div className="lump-content">
                <h3>Lump Details </h3>

                <table style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Barcode</th>
                            <th>Color</th>
                            <th>Given Mtr</th>
                            <th>Lump Mtr</th>
                            <th>Bal Mtr</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lumpRows?.map((lumpRow, lumpIndex) => (
                            <>
                                <tr key={lumpIndex}>
                                    <td> <input
                                        type="checkbox"
                                        checked={lumpRow.selected}
                                        onChange={() => handleLumpSelection(lumpIndex)}
                                    />{" "}
                                        {lumpIndex + 1}
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="barcode"
                                            value={lumpRow.barcode}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="color"
                                            value={lumpRow.color}
                                            // onChange={(e) => handleLumpColor(
                                            //     lumpIndex,
                                            //     e.target.value
                                            // )}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        {lumpRow.bmtr}

                                    </td>
                                    <td>
                                        {lumpRow.loose === '1' && <span>Loose -</span>}
                                        <input
                                            type="text"
                                            placeholder="Lump Mtr"
                                            value={lumpRow.bmtr2}
                                            onChange={(e) => handleLumpMtr(
                                                lumpIndex,
                                                e.target.value
                                            )}
                                        // readOnly
                                        />
                                    </td>
                                    <td>
                                        {lumpRow.balmtr}
                                    </td>
                                </tr>
                            </>
                        ))}
                        <tr>
                            <td> </td>
                            <td> </td>
                            <td>
                                <span className="tot-lump">Total Lump Mtr</span>
                            </td>
                            <td>
                                <span className="tot-lump">{lumpTotMtr}</span>
                            </td>
                            <td>
                                <span className="tot-lump">{formData.usemtr1}</span>
                            </td>
                            <td>
                                <span className="tot-lump">{formData.balmtr1}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                {isAnyRowSelected && (
                    <div className="button-group">
                        <button className="add" onClick={handleAddlump}>Add</button>
                    </div>
                )}
                <h3>Issue Lumps</h3>

                {isAnyNewRowSelected &&
                    (<div className="button-group">
                        <button className="add" onClick={handleRemoveLumps}>Remove</button>
                    </div>)
                }
                <table style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Barcode</th>
                            <th>Color</th>
                            <th>Given Mtr</th>
                            <th>Lump Mtr</th>
                            <th>Bal Mtr</th>
                        </tr>
                    </thead>
                    <tbody>
                        {newLumprows.map((lumpRow, lumpIndex) => (
                            <>
                                <tr key={lumpIndex}>
                                    <td><input
                                        type="checkbox"
                                        checked={lumpRow.selected2}
                                        onChange={() => handleLumpSelection2(lumpIndex)}
                                    />{" "}
                                        {lumpIndex + 1}
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="barcode"
                                            value={lumpRow.barcode}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="color"
                                            value={lumpRow.color}
                                            // onChange={(e) => handleLumpColor(
                                            //     lumpIndex,
                                            //     e.target.value
                                            // )}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        {lumpRow.bmtr}

                                    </td>
                                    <td>
                                        {lumpRow.loose === '1' && <span>Loose -</span>}
                                        <input
                                            type="text"
                                            placeholder="Lump Mtr"
                                            name='mtr'
                                            value={lumpRow.bmtr2}
                                            // onChange={(e) => handleLumpMtr(
                                            //     lumpIndex,
                                            //     e.target.value
                                            // )}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        {lumpRow.balmtr}
                                    </td>
                                </tr>
                            </>
                        ))}
                        <tr>
                            <td> </td>
                            <td> </td>
                            <td>
                                <span className="tot-lump">Total Lump Mtr</span>
                            </td>
                            <td>
                                <span className="tot-lump">{newTotMtr}</span>
                            </td>
                            <td>
                                <span className="tot-lump">{formData.usemtr2}</span>
                            </td>
                            <td>
                                <span className="tot-lump">{formData.balmtr2}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                {newLumprows?.length > 0 &&
                    <button className="add" onClick={handleSubmit}>Submit</button>
                }
            </div >
        </>
    );
}

export default ClothIssueLump;
